export default __webpack_public_path__ + "assets/webgl/LightCone.3023468d.bin";